// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "styles" + "." + "b982b405f35b16710a07" + ".css";
};